import { Gutters } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useBoundStore } from '../../../state/bound.store'
import { selectorOriginalItinCodes } from '../../../state/itineraryState/itineraryMap.slice'
import { NavigationView } from '../../layout/NavigationView'
import { PublicItinEntry } from '../components/publicItinEntry'

export const PublicItinPage = () => {
    const publicItinCodes = useBoundStore(selectorOriginalItinCodes)

    return (
        <>
            <NavigationView
                usePageTransition
                navigationBarTitle={'Public Itineraries'}
                backButtonAction={() => window.goBack()}
            >
                <Gutters>
                    <Stack spacing={'8px'}>
                        {(publicItinCodes ?? []).map((itin, i) => {
                            return <PublicItinEntry key={i} itinCode={itin} />
                        })}
                    </Stack>
                </Gutters>
            </NavigationView>
        </>
    )
}
